import * as yup from "yup";

export const validationSchema = yup.object().shape({
  title: yup.string().required("Başlık alanı zorunludur"),
  definitions: yup
    .array()
    .required("İçerik tanımı alanı zorunludur")
    .min(1, "En az 1 içerik tanımı yapılmalıdır"),
});
